import {set} from '@/utils/vuex'

export default {
  setSelectedItems: set('selectedItems'),
  setSelectedItemsInBundling: set('selectedItemsInBundling'),
  setEditQuoRecord: set('editQuoRecord')
}
